import { Chip } from '@mui/material';
import React from 'react';
import StudentImpactOverview from '../StudentImpactOverview';

const yesNo = (value, yesColour = 'success') => (
  <Chip
    size="small"
    variant="outlined"
    color={value ? yesColour : 'default'}
    label={value ? 'Yes' : 'No'}
  />
);

/**
 * columns for the impact report analytics table.
 * ONE ROW IS ONE STUDENT ( keyed on admn_no ) , so the course / subject / test figures
 * are aggregates across every ACTIVE enrollment that student has under this cro.
 * @author Akhil E M
 * @createdAt 11-08-2026
 * @updates 11-08-2026(Akhil EM),
 * @type array
 */
export const impactReportAnalyticsHeader = [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  { field: 'admn_no', headerName: 'Admission No', width: 150, sortable: true },
  { field: 'student_name', headerName: 'Student', width: 220, toolTipGetter: true },
  { field: 'class_name', headerName: 'Class', width: 110 },
  { field: 'syllabus_name', headerName: 'Syllabus', width: 140 },
  { field: 'student_mobile', headerName: 'Mobile', width: 170 },
  { field: 'course_count', headerName: 'Courses', width: 110 },
  { field: 'subject_count', headerName: 'Subjects', width: 110 },
  { field: 'test_count', headerName: 'Tests Recorded', width: 150 },
  {
    field: 'has_pre',
    headerName: 'Pre Assessment',
    width: 160,
    renderCell: ({ row }) => yesNo(row?.has_pre),
  },
  {
    field: 'has_post',
    headerName: 'Post Assessment',
    width: 165,
    renderCell: ({ row }) => yesNo(row?.has_post),
  },
  {
    field: 'report_downloaded',
    headerName: 'Report Downloaded',
    width: 185,
    renderCell: ({ row }) => yesNo(row?.report_downloaded, 'info'),
  },
  {
    field: 'overall_impact',
    headerName: 'Overall Impact Report',
    width: 200,
    //ALL OF THE STUDENT'S SUBJECTS IN ONE POPUP , UNLIKE THE CRO DASHBOARD'S PER SUBJECT VIEW
    renderCell: ({ row }) => <StudentImpactOverview row={row} />,
  },
  {
    field: 'last_test_on',
    headerName: 'Last Test On',
    width: 170,
    valueGetter: ({ row }) =>
      row?.last_test_on ? String(row.last_test_on).slice(0, 10).split('-').reverse().join('-') : '—',
  },
];
